import fieldManagement from "./fieldManagement";
import channel from "./channel";
import habitatImprovement from "./habitatImprovement";

const questionnaireService = [
    {
        matcher: 'questionnaires/fieldManagement',
        reply: config => {
            return [200, fieldManagement];
        }
    },
    {
        matcher: 'questionnaires/channel',
        reply: config => {
            return [200, channel];
        }
    },
    {
        matcher: 'questionnaires/habitatImprovement',
        reply: config => {
            return [200, habitatImprovement];
        }
    }
]

export default questionnaireService;